export const tags = [
    'RadiopharmaceuticalStartTime',
    'RadiopharmaceuticalStopTime',
    'RadionuclideTotalDose',
    'RadionuclideHalfLife',
];
